/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssignOrderRequest } from '../models/AssignOrderRequest';
import type { CreateOrderMessageRequest } from '../models/CreateOrderMessageRequest';
import type { Order } from '../models/Order';
import type { RentalTimeUpdateRequest } from '../models/RentalTimeUpdateRequest';
import type { SetRelatedOrderRequest } from '../models/SetRelatedOrderRequest';
import type { SignatureRequest } from '../models/SignatureRequest';
import type { TransferOrderRequest } from '../models/TransferOrderRequest';
import type { UpdateOrderRequest } from '../models/UpdateOrderRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrderService {
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiOrder(
        requestBody?: Order,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Order',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiOrderCreateAdminOrder(
        requestBody?: Order,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Order/CreateAdminOrder',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @returns Order OK
     * @throws ApiError
     */
    public static getApiOrder(
        orderId: string,
    ): CancelablePromise<Order> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Order/{orderID}',
            path: {
                'orderID': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiOrder(
        orderId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Order/{orderID}',
            path: {
                'orderID': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @returns any OK
     * @throws ApiError
     */
    public static getApiOrderFlightLatestInfo(
        orderId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Order/{orderID}/FlightLatestInfo',
            path: {
                'orderID': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getApiOrderOrders(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Order/Orders',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param teamCode
     * @param yearMonth
     * @returns any OK
     * @throws ApiError
     */
    public static getApiOrderGetOrdersByTeamCode(
        teamCode: string,
        yearMonth?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Order/GetOrdersByTeamCode/{teamCode}',
            path: {
                'teamCode': teamCode,
            },
            query: {
                'yearMonth': yearMonth,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getApiOrderTakenOrders(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Order/TakenOrders',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getApiOrderPendingOrders(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Order/PendingOrders',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @returns any OK
     * @throws ApiError
     */
    public static putApiOrderRideOrder(
        orderId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Order/RideOrder',
            query: {
                'orderID': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @returns any OK
     * @throws ApiError
     */
    public static putApiOrderCompleteOrder(
        orderId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Order/CompleteOrder',
            query: {
                'orderID': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @returns any OK
     * @throws ApiError
     */
    public static putApiOrderTakeOrder(
        orderId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Order/TakeOrder',
            query: {
                'orderID': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiOrderAssignOrder(
        orderId: string,
        requestBody?: AssignOrderRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Order/{orderID}/AssignOrder',
            path: {
                'orderID': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @returns any OK
     * @throws ApiError
     */
    public static putApiOrderCancelTakenOrder(
        orderId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Order/CancelTakenOrder',
            query: {
                'orderID': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @returns any OK
     * @throws ApiError
     */
    public static putApiOrderCancelOrder(
        orderId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Order/CancelOrder',
            query: {
                'orderID': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @returns any OK
     * @throws ApiError
     */
    public static getApiOrderMessages(
        orderId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Order/{orderID}/Messages',
            path: {
                'orderID': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiOrderMessages(
        orderId: string,
        requestBody?: CreateOrderMessageRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Order/{orderID}/Messages',
            path: {
                'orderID': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @returns any OK
     * @throws ApiError
     */
    public static putApiOrderMessagesRead(
        orderId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Order/{orderID}/Messages/Read',
            path: {
                'orderID': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiOrderSaveSignature(
        orderId: string,
        requestBody?: SignatureRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Order/{orderID}/SaveSignature',
            path: {
                'orderID': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @returns any OK
     * @throws ApiError
     */
    public static getApiOrderViewRentForm(
        orderId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Order/{orderID}/ViewRentForm',
            path: {
                'orderID': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiOrderUpdateRentalTimes(
        orderId: string,
        requestBody?: RentalTimeUpdateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Order/{orderID}/UpdateRentalTimes',
            path: {
                'orderID': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiOrderSetRelatedOrder(
        orderId: string,
        requestBody?: SetRelatedOrderRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Order/{orderID}/SetRelatedOrder',
            path: {
                'orderID': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiOrderTransferOrder(
        orderId: string,
        requestBody?: TransferOrderRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Order/{orderID}/TransferOrder',
            path: {
                'orderID': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiOrderUpdateOrderDetails(
        orderId: string,
        requestBody?: UpdateOrderRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Order/{orderID}/UpdateOrderDetails',
            path: {
                'orderID': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
